<template>
  <VDialog width="500" v-model="dialog">
    <VCard>
      <VBtn @click="dialog = false" class="mt-3" icon absolute right>
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle>{{ $t("finishOrder") }}</VCardTitle>
      <VCardText>
        <p v-if="receivedComment">{{ receivedComment }}</p>
        <ValidationObserver v-else v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit(submit)">
            <CustomTextTextarea
              autofocus
              rules="required"
              :label="$t('requestFinishHint')"
              v-model="completeFormData.comment"
              class="user_input"
            ></CustomTextTextarea>
            <div class="text-right mt-4">
              <VBtn :loading="loading" color="primary" type="submit"
                >{{ $t("send") }}
              </VBtn>
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  name: "FinishOrderItemDialog",
  data() {
    return {
      receivedComment: null,
      dialog: false,
      loading: false,
      completeFormData: {
        comment: null,
        id: null,
      },
    };
  },
  emits: ["completed"],
  methods: {
    open({ id, receivedComment }) {
      this.receivedComment = receivedComment;
      this.dialog = true;
      this.completeFormData.id = id;
    },
    async submit() {
      this.loading = true;
      try {
        await this.$http.post("office/order/complete", this.completeFormData);
        this.$emit("completed");
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.dialog = false;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        const { form } = this.$refs;
        this.completeFormData = {};
        this.receivedComment = null;
        this.loading = false;
        if (form) {
          form.reset();
        }
      }
    },
  },
};
</script>
